<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card outlined>
          <v-row>
            <v-col cols="12">
              <v-container py-0 fluid>
                <v-row justify="end" align="center">
                  <v-col sm="3">
                    <v-select
                      v-if="showGroupedView"
                      :items="groupByOptions"
                      v-model="selectedGroupedBy"
                      label="Group by"
                      item-text="name"
                      return-object
                      :outlined="outlinedInputs"
                      hide-details
                      width="200px"
                    ></v-select>
                  </v-col>
                  <v-switch
                    prepend-icon="mdi-view-list"
                    class="pr-3"
                    label="Group View"
                    v-model="showGroupedView"
                  ></v-switch>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
          <v-row v-if="showGroupedView">
            <v-col cols="12">
              <v-container fluid>
                <list-grouped :group="selectedGroupedBy" :items="items">
                  <template v-slot:table="{ items }">
                    <v-card outlined>
                      <templates-table
                        :items="items"
                        :headers="headers"
                        :search="search"
                        :templateDays="templateDays"
                        :duration="duration"
                        @onEditItemPrices="onEditItemPrices"
                        @onItemRemove="onItemRemove"
                        @onSaveServiceDuration="onSaveServiceDuration"
                        @onSaveServiceDay="onSaveServiceDay"
                        @onExtraRemove="onExtraRemove"
                        @itemIncludedChange="onItemIncludedChange"
                      ></templates-table>
                    </v-card>
                  </template>
                </list-grouped>
              </v-container>
            </v-col>
          </v-row>

          <templates-table
            v-else
            :items="items"
            :headers="headers"
            :search="search"
            :templateDays="templateDays"
            :duration="duration"
            @onEditItemPrices="onEditItemPrices"
            @onItemRemove="onItemRemove"
            @onSaveServiceDuration="onSaveServiceDuration"
            @onSaveServiceDay="onSaveServiceDay"
            @onExtraRemove="onExtraRemove"
            @supplier-edit="onSupplierEdit"
            @itemIncludedChange="onItemIncludedChange"
          ></templates-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-row v-if="debug">
      <v-col
        ><code>{{ items }}</code></v-col
      >
    </v-row>
    <template-builder-item-pricing-dialog
      v-model="editedItem"
      :show="showPricingDialog"
      @close="showPricingDialog = false"
      @save="onItemSave"
      @supplier-edit="onSupplierEdit"
    ></template-builder-item-pricing-dialog>
  </v-container>
</template>

<script>
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";

import TemplateBuilderItemPricingDialog from "./TemplateBuilderItemPricingDialog";
import ListGrouped from "../../shared/ListGrouped";
import TemplatesTable from "./TemplatesTable";
export default {
  name: "TemplateBuilderItemsList",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    duration: {
      type: Number,
      default: () => 7,
    },
  },

  mixins: [SupplierTypeIconMixin],

  components: {
    TemplateBuilderItemPricingDialog,
    ListGrouped,
    TemplatesTable,
  },

  data() {
    return {
      debug: false,
      showGroupedView: false,
      selectedGroupedBy: {
        name: "Day",
        getKey: (item) => item.day,
        getLabel: (item) => `Day No: ${item.day}`,
      },
      groupByOptions: [
        {
          name: "Day",
          getKey: (item) => item.day,
          getLabel: (item) => `Day No: ${item.day}`,
        },
        {
          name: "Supplier Type",
          getKey: (item) => item.serviceType,
          getLabel: (item) => `${item.serviceType}`,
        },
        {
          name: "Supplier",
          getKey: (item) => item.supplierName,
          getLabel: (item) => `${item.supplierName}`,
        },
      ],
      search: "",
      visibleColumns: ["serviceName"],
      headers: [
        {
          text: "Type",
          value: "serviceType",
          sortable: false,
          name: "serviceType",
        },
        {
          text: "Day",
          value: "day",
          sortable: false,
          name: "day",
        },
        {
          text: "Duration",
          value: "duration",
          sortable: false,
          name: "duration",
        },
        {
          text: "Order",
          value: "order",
          sortable: true,
          name: "order",
        },
        {
          text: "Supplier",
          value: "supplierName",
          sortable: false,
          name: "supplierName",
        },
        {
          text: "Service Name",
          value: "serviceName",
          sortable: false,
          name: "serviceName",
        },
        {
          text: "Hidden",
          value: "hidden",
          sortable: false,
          name: "hidden",
        },
        {
          text: "Included",
          value: "included",
          sortable: false,
          name: "included",
        },
        {
          text: "Optional",
          value: "optional",
          sortable: false,
          name: "optional",
        },

        { text: "Actions", value: "actions", sortable: false, name: "actions" },
      ],

      editedItem: null,
      showPricingDialog: false,
    };
  },

  computed: {
    templateDays() {
      return [...Array(this.duration).keys()].map((i) => ++i);
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onItemIncludedChange(item) {
      console.log("onItemIncludedChange", item);
      const editedItem = this.items.find((i) => i.id == item.id);
      if (editedItem) {
        for (const extra of editedItem.extras) {
          extra.included = item.included;
        }
      }
      this.$emit("itemIncludedChange", editedItem);
    },
    extraTemplateDays(item) {
      const days = [];
      for (
        let i = parseInt(item.day);
        i <= Number(item.day) + Number(item.duration) - 1;
        i++
      ) {
        days.push(i);
      }
      return days;
    },
    itemMaxDuration(item) {
      let maxDuration = this.duration - Number(item.day);
      if (maxDuration <= 0) {
        maxDuration = 1;
      }
      return maxDuration;
    },
    onSaveExtraDay(item, extra) {
      const extraMaxDuration =
        Number(item.day) + Number(item.duration) - Number(extra.day);
      if (extra.duration > extraMaxDuration) {
        extra.duration = extraMaxDuration;
      }
    },
    extraAvailableDurations(item, extra) {
      let maxDur = Number(item.day) + Number(item.duration) - Number(extra.day);
      if (maxDur <= 0) {
        maxDur = 1;
      }
      return [...Array(maxDur).keys()].map((i) => ++i);
    },
    itemAvailableDurations(item) {
      return [...Array(this.itemMaxDuration(item)).keys()].map((i) => ++i);
    },
    onSaveServiceDay(item) {
      const maxDuration = this.itemMaxDuration(item);
      if (Number(item.duration) > maxDuration) {
        item.duration = maxDuration;
      }
      //update extras
      this.updateItemExtras(item);
    },
    onSaveServiceDuration(item) {
      //update extras
      this.updateItemExtras(item);
    },
    updateItemExtras(item) {
      for (const extra of item.extras) {
        extra.day = item.day;
        extra.duration = item.duration;
      }
    },
    onItemRemove(item) {
      // const index = this.items.indexOf(item);
      // this.items.splice(index, 1);
      this.$emit("remove-item", item);
    },
    onEditItemPrices(item) {
      this.editedItem = { ...item };
      this.showPricingDialog = true;
    },
    customPricingFlagColor(item) {
      return item.customPricing ? "green darken-2" : "blue lighten-1";
    },
    onItemSave(data) {
      //console.log("saving item", data);
      this.showPricingDialog = false;
      this.$emit("updateItem", { ...this.editedItem });
    },
    expandExtras(item) {
      const isExpanded = this.expanded.find((i) => i.id == item.id);
      this.expanded = isExpanded
        ? [...this.expanded.filter((i) => i.id != item.id)]
        : [...this.expanded, item];
    },
    onExtraRemove(extra, item) {
      //console.log(extra, item);
      const editedItem = this.items.find((i) => i.id == item.id);
      if (editedItem) {
        editedItem.extras = [
          ...editedItem.extras.filter((e) => e.id != extra.id),
        ];
        if (editedItem.extras.length == 0) {
          this.expanded = [...this.expanded.filter((i) => i.id != item.id)];
        }
      }
    },
    onSupplierEdit(payload) {
      this.$emit("supplier-edit", payload);
    },
  },
};
</script>

<style>
.t-items-table tr td:first-child:not(:only-child) {
  width: 80px;
}
.t-items-table tr td:last-child:not(:only-child) {
  width: 100px;
}
.t-items-table tr td:nth-child(2),
.t-items-table tr td:nth-child(3),
.t-items-table tr td:nth-child(4) {
  width: 100px;
}
.t-items-table tr td:nth-child(5) {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/TemplateBuilderItemsList.vue